var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 398.46 82.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 20.19,
    x2: 34.32,
    y2: 20.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.38,
    y1: 20.46,
    x2: 70.98,
    y2: 20.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 86.46,
    y1: 20.88,
    x2: 116.04,
    y2: 20.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 113.82,
    y1: 20.46,
    x2: 153.42,
    y2: 20.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 150.06,
    y1: 20.19,
    x2: 184.38,
    y2: 20.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 189.3,
    y1: 20.88,
    x2: 205.38,
    y2: 20.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 210.48,
    y1: 20.91,
    x2: 234.48,
    y2: 20.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 240.48,
    y1: 20.91,
    x2: 264.48,
    y2: 20.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 269.64,
    y1: 20.88,
    x2: 285.72,
    y2: 20.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 291.18,
    y1: 20.82,
    x2: 322.92,
    y2: 20.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 327.12,
    y1: 21.12,
    x2: 362.93,
    y2: 21.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 364.43,
    y1: 20.82,
    x2: 396.17,
    y2: 20.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 228.67,
    y1: 64.05,
    x2: 257.99,
    y2: 64.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eaeae9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d0d0cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#acacab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 250.52,
    y1: 76.08,
    x2: 267.41,
    y2: 76.08,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 265.32,
    y1: 63.95,
    x2: 288.86,
    y2: 63.95,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 283.72,
    y1: 75.53,
    x2: 295.9,
    y2: 75.53,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 300.17,
    y1: 63.56,
    x2: 334.1,
    y2: 63.56,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 327.74,
    y1: 70.45,
    x2: 347.93,
    y2: 70.45,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 342.98,
    y1: 76.62,
    x2: 360.6,
    y2: 76.62,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 359.63,
    y1: 63.56,
    x2: 387.49,
    y2: 63.56,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 376.08,
    y1: 72.52,
    x2: 385.21,
    y2: 72.52,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 384.53,
    y1: 75.6,
    x2: 398.46,
    y2: 75.6,
    xlinkHref: "#linear-gradient-13"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0420\u0435\u0441\u0443\u0440\u0441 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.52,10.8a22.76,22.76,0,0,0-1.92-5c-1-1.62-1.56-2-4.86-2h-6V33c0,4.68.48,5.34,6.18,5.7v1.68H8.46V38.7c5.58-.36,6.06-1,6.06-5.7V3.78H9.06c-3.3,0-4.26.36-5.28,2.16a27.41,27.41,0,0,0-2,4.86H0C.36,7.14.72,3.36.9,0H2.28c.9,1.44,1.56,1.38,3.24,1.38H29.28c1.68,0,2.16-.24,3.06-1.38h1.44c0,2.82.24,7.14.54,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.16,40.38V38.7c3.9-.48,4.38-1.08,3.54-3.36s-2-5.34-3.24-9.12h-13c-1,2.7-1.86,5-2.7,7.5-1.32,3.9-.48,4.38,4.44,5v1.68H31.38V38.7c3.78-.48,4.74-.9,6.84-6.3L50.64.9,52.56.54c3.78,10.26,7.92,21.6,11.7,32,1.92,5.22,2.46,5.7,6.72,6.18v1.68Zm-6-32c-1.92,5.16-4,10.62-5.76,15.36H55.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.94,1.38c4.26,0,7.68.78,10.14,2.58a10.14,10.14,0,0,1,4,8.52c0,8.76-7.5,12.3-13.2,12.3a10.54,10.54,0,0,1-1.62-.12l-4.14-1.08v9.36c0,5,.42,5.16,5.94,5.76v1.68H86.46V38.7c5.16-.54,5.4-.9,5.4-5.88V9c0-5.34-.66-5.46-5.4-5.94V1.38Zm-4.86,20.1a10.89,10.89,0,0,0,4.38.78c4,0,9-2,9-9.6,0-6.6-4.32-9.24-9.36-9.24-1.74,0-3,.3-3.36.72s-.66,1.14-.66,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.6,40.38V38.7c3.9-.48,4.38-1.08,3.54-3.36s-2-5.34-3.24-9.12h-13c-1,2.7-1.86,5-2.7,7.5-1.32,3.9-.48,4.38,4.44,5v1.68H113.82V38.7c3.78-.48,4.74-.9,6.84-6.3L133.08.9,135,.54c3.78,10.26,7.92,21.6,11.7,32,1.92,5.22,2.46,5.7,6.72,6.18v1.68Zm-6-32c-1.92,5.16-4,10.62-5.76,15.36h11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M182.58,10.8a22.76,22.76,0,0,0-1.92-5c-1-1.62-1.56-2-4.86-2h-6V33c0,4.68.48,5.34,6.18,5.7v1.68H158.52V38.7c5.58-.36,6.06-1,6.06-5.7V3.78h-5.46c-3.3,0-4.26.36-5.28,2.16a27.41,27.41,0,0,0-2,4.86h-1.8c.36-3.66.72-7.44.9-10.8h1.38c.9,1.44,1.56,1.38,3.24,1.38h23.76c1.68,0,2.16-.24,3.06-1.38h1.44c0,2.82.24,7.14.54,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.3,40.38V38.7c4.92-.54,5.4-.78,5.4-5.88V9c0-5.16-.48-5.4-5.4-5.94V1.38h16.08V3.06c-5,.54-5.46.78-5.46,5.94V32.82c0,5.16.48,5.34,5.46,5.88v1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M231.18,10.5c-1-4-2.7-7.86-8.34-7.86-4.68,0-6.3,3.42-6.3,6.54,0,4.14,2.64,6.24,7.62,8.82,7.2,3.72,10.32,6.48,10.32,12.18,0,6.3-5.46,11.1-13.2,11.1a25,25,0,0,1-9.18-2,81.87,81.87,0,0,1-1.62-9l1.86-.48c1.2,4,3.84,9.24,10.08,9.24a6.6,6.6,0,0,0,7-6.9c0-4.62-2.46-6.48-7.74-9.36-6.3-3.42-9.84-6.3-9.84-11.88,0-5.34,4.44-10.38,12.36-10.38a38.41,38.41,0,0,1,7.92,1.14c.24,2.16.48,4.56,1,8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M261.18,10.5c-1-4-2.7-7.86-8.34-7.86-4.68,0-6.3,3.42-6.3,6.54,0,4.14,2.64,6.24,7.62,8.82,7.2,3.72,10.32,6.48,10.32,12.18,0,6.3-5.46,11.1-13.2,11.1a25,25,0,0,1-9.18-2,81.87,81.87,0,0,1-1.62-9l1.86-.48c1.2,4,3.84,9.24,10.08,9.24a6.6,6.6,0,0,0,7-6.9c0-4.62-2.46-6.48-7.74-9.36-6.3-3.42-9.84-6.3-9.84-11.88,0-5.34,4.44-10.38,12.36-10.38a38.41,38.41,0,0,1,7.92,1.14c.24,2.16.48,4.56,1,8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M269.64,40.38V38.7c4.92-.54,5.4-.78,5.4-5.88V9c0-5.16-.48-5.4-5.4-5.94V1.38h16.08V3.06c-5,.54-5.46.78-5.46,5.94V32.82c0,5.16.48,5.34,5.46,5.88v1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M322.92,30.84c-.37,1.56-2,7.74-2.59,9.54H291.18V38.7c5.58-.42,6-1,6-5.88V9.12c0-5.34-.66-5.64-5.16-6.06V1.38h18.36c5.63,0,8-.06,8.7-.12.05,1.5.3,6,.54,9.18l-1.8.3A20,20,0,0,0,316,6.18c-1-2-2.34-2.4-5.93-2.4h-5.7c-1.86,0-2,.18-2,1.92V19h6.66c4.5,0,4.8-.9,5.52-5h1.85V26.34h-1.85c-.79-4.32-1.26-4.92-5.58-4.92h-6.6V33.36c0,4.2,1.32,4.56,4.32,4.62h5.57c3.67,0,4.26-.54,5.59-2.1a26.58,26.58,0,0,0,3.24-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M362.69,40.86c-.78,0-1.44-.06-2.22-.12-4.38-.3-6.72-1.44-9.36-5.16-2.22-3.06-4.38-6.84-6.3-9.9-1.2-1.92-2-2.28-5-2.28h-2.1v9.42c0,5.1.66,5.4,5.46,5.88v1.68h-16V38.7c5-.54,5.39-.78,5.39-5.88V8.88c0-5.1-.66-5.28-5.39-5.82V1.38h15.29c4.38,0,7.32.54,9.6,2a9,9,0,0,1,4.08,7.92c0,5.16-3.3,8.4-7.74,10.32,1.08,1.86,3.66,5.88,5.46,8.58a55.09,55.09,0,0,0,4.74,6.18,8.64,8.64,0,0,0,4.38,2.76Zm-22.14-19.5c3.12,0,5.1-.48,6.6-1.74,2.34-1.74,3.3-4.14,3.3-7.38,0-6.42-4.26-8.76-8.88-8.76-1.74,0-2.76.24-3.18.6s-.72,1-.72,2.58v14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M396.17,30.84c-.36,1.56-2,7.74-2.58,9.54H364.43V38.7c5.58-.42,6-1,6-5.88V9.12c0-5.34-.66-5.64-5.16-6.06V1.38h18.36c5.64,0,8-.06,8.7-.12.06,1.5.3,6,.54,9.18l-1.8.3a20,20,0,0,0-1.8-4.56c-1-2-2.34-2.4-5.94-2.4h-5.7c-1.86,0-2,.18-2,1.92V19h6.66c4.5,0,4.8-.9,5.52-5h1.86V26.34h-1.86c-.78-4.32-1.26-4.92-5.58-4.92h-6.6V33.36c0,4.2,1.32,4.56,4.32,4.62h5.58c3.66,0,4.26-.54,5.58-2.1a25.73,25.73,0,0,0,3.24-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M258,48.76q0,4.13-3.74,9.24t-7,5.13c-1.16,0-1.74-.7-1.74-2.09a5.56,5.56,0,0,1,1.07-3.21,23.1,23.1,0,0,1,2.47-2.76.54.54,0,0,1,.34-.2c.19,0,.29.13.29.39q-3.54,2.87-3.54,5.58a2,2,0,0,0,.41,1.19,1.23,1.23,0,0,0,1,.56c1.4,0,3.19-1.48,5.39-4.45q3.5-4.78,3.5-9c0-2-1-3-3-3-3.21,0-6.68,1.5-10.44,4.5a37.34,37.34,0,0,0-8.78,10.41q-3.75,6.39-3.74,11.52a10.14,10.14,0,0,0,2.13,6.63A7,7,0,0,0,238.38,82q6.17,0,13.54-7.33a.7.7,0,0,1,.25-.1c.13,0,.19.08.19.24a1.08,1.08,0,0,1-.39.73,27.74,27.74,0,0,1-4.71,3.93,17.84,17.84,0,0,1-9.75,3.3q-4.86,0-7.14-3.15a10,10,0,0,1-1.7-5.92q0-5.1,3.79-11.87a39,39,0,0,1,9.37-11.33q6.16-5.1,12-5.1Q258,45.36,258,48.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M267.41,76.76c0,.39-1,1.14-3,2.24s-3.61,1.74-4.52,1.74c-1.68,0-2.52-.88-2.52-2.66a2.73,2.73,0,0,1,.78-1.66s0,0-.05,0-.84.67-2.62,2-3.06,2-3.84,2-1.11-.3-1.11-.92q0-2.24,3.73-5.19c2.37-1.91,4.21-2.86,5.54-2.86a1.72,1.72,0,0,1,.65.29c.24.17.37.3.37.39a.14.14,0,0,1-.05.09c-1.81,0-4.13,1.42-6.94,4.25a3.75,3.75,0,0,0-1.36,2.3.3.3,0,0,0,.34.34q1.06,0,4.07-2.47a29.85,29.85,0,0,0,3.45-3.25c.32-.39.55-.59.68-.59.32,0,.49.23.49.68a3.19,3.19,0,0,1-.64,1.11c-1.39,1.89-2.08,3.1-2.08,3.61q0,1.35,1.5,1.35c1.65,0,3.89-.94,6.7-2.82a.44.44,0,0,1,.29-.14C267.36,76.57,267.41,76.64,267.41,76.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M288.86,48q0,5-4.66,11.6a60.7,60.7,0,0,1-8.88,10c-3.08,2.82-4.94,4.22-5.58,4.22q-2.28,4.71-2.28,5.44,2.76-2.67,5.58-5.34,5.54-4.91,8.15-4.9,1,.15,1,.87a4.44,4.44,0,0,1-1.94,3.59c-1.2.75-2.41,1.48-3.64,2.19s-1.94,1.67-1.94,2.57c0,1.42.56,2.14,1.7,2.14q2,0,7-3.21a4.64,4.64,0,0,1,.67-.43.43.43,0,0,1,.3-.15c.09,0,.14.07.14.19a4.56,4.56,0,0,1-.63.68,16,16,0,0,1-4,2.6,10.88,10.88,0,0,1-4.27,1.43c-1.75,0-2.62-.84-2.62-2.52a3.82,3.82,0,0,1,1.93-3.25l3.59-2.11a3.11,3.11,0,0,0,1.86-2.6c0-.45-.21-.68-.63-.68q-1.55,0-7.48,5.58t-6.36,5.58c-.39,0-.58-.21-.58-.53a1.76,1.76,0,0,1,.29-.83l4.66-9.52A164.28,164.28,0,0,1,279,54.74q5.39-8.31,8.35-8.31A1.37,1.37,0,0,1,288.86,48Zm-1.41.73c0-.74-.29-1.12-.87-1.12q-4.36,1.13-16.36,25.29,1.32-.43,5.44-4.61a64.72,64.72,0,0,0,7.81-9.51Q287.46,52.75,287.45,48.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M295.9,76.76c0,.23-.66.77-2,1.61-3.27,2.07-5.61,3.1-7,3.1q-3.15,0-3.15-3.69a8,8,0,0,1,2.64-5.46c1.77-1.82,3.44-2.74,5-2.74.48,0,.72.23.72.68q0,1.63-2.86,4.64a20,20,0,0,1-3.74,3.23q.15,2.13,2,2.13c1.2,0,3.2-.8,6-2.4.23-.12.86-.51,1.89-1.15a.46.46,0,0,1,.29-.14C295.85,76.57,295.9,76.64,295.9,76.76Zm-5.29-5.58c0-.39-.11-.58-.34-.58-.81,0-1.8.81-3,2.43a8.06,8.06,0,0,0-1.8,4.37,9.06,9.06,0,0,0,2.91-2.53Q290.61,72.44,290.61,71.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M334.1,47.25q0,2.47-8.55,13.11l3.69,4.76q2,2.76,1.95,4.51,0,4.66-5.25,8.37a20.88,20.88,0,0,1-12.42,3.72,26.68,26.68,0,0,1-9.18-1.41q-4.17-1.5-4.17-3.89c0-.38.29-.76.87-1.11a3.84,3.84,0,0,1,2-.54,13.48,13.48,0,0,1,4.56,1,15.28,15.28,0,0,1,3.84,2,.42.42,0,0,1,.19.34c0,.2-.09.29-.29.29a.8.8,0,0,1-.43-.14q-2.34-1.36-3-1.65a11.88,11.88,0,0,0-5-1.17c-1,0-1.46.39-1.46,1.16,0,1.28,1.38,2.36,4.13,3.22a24.16,24.16,0,0,0,7.28,1.11,21.69,21.69,0,0,0,11.31-2.76q5.15-3.11,5.14-8.52a7.38,7.38,0,0,0-1.6-4.12q-.58-.83-3.25-3.82-5.3,6.56-11.75,13.88a.35.35,0,0,1-.39-.4,1.85,1.85,0,0,1,.41-.75l11.13-13.38c-1.41-1.71-2.12-3.09-2.12-4.12q0-3.54,3.3-7.47,3.49-4.06,7.09-4.07C333.45,45.41,334.1,46,334.1,47.25Zm-1.6.78A1.27,1.27,0,0,0,331,46.62q-2.32,0-5,3.16a9.55,9.55,0,0,0-2.62,6,7.58,7.58,0,0,0,1.6,3.88Q332.5,50.51,332.5,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M347.93,59.82a1.22,1.22,0,0,1-.19.59q-2.24,3.83-6.12,11.6a22.78,22.78,0,0,0,4.27-.29,1.27,1.27,0,0,1,.05.39q0,.24-.39.33a27.4,27.4,0,0,1-4.22.2q-2.62,5.24-4.71,8.83c-.29.49-.55.73-.78.73s-.53-.21-.53-.63a3,3,0,0,1,.29-1,27.53,27.53,0,0,0,1.65-7.62A44.68,44.68,0,0,1,330,78.61q-.24-.1-.24-.24c0-.23.24-.47.73-.73a44.41,44.41,0,0,0,6.74-5.49,15,15,0,0,1-6.31-3,8.12,8.12,0,0,1-3.15-6.5A3.92,3.92,0,0,1,328.93,60a3.62,3.62,0,0,1,2.69-1.26q2.72,0,4.52,3a16.23,16.23,0,0,1,1.89,8.4v1.31a79.48,79.48,0,0,0,6.47-7.33l2.8-4.71a.69.69,0,0,1,.39.19C347.85,59.66,347.93,59.76,347.93,59.82ZM337.45,70.07A15.81,15.81,0,0,0,336,63.56q-1.76-3.83-4.56-3.83-2.43,0-2.43,2.67a7.8,7.8,0,0,0,2.77,5.87,14,14,0,0,0,5.58,3.2,5.21,5.21,0,0,1,.05-.72Zm2.47,2.52c-.61-.06-1.26-.16-2-.29a38,38,0,0,1-.72,4.92L337,78.58l.6-1.23Zm2.62-5.14-.82.92q-1.65,1.84-3.21,3.4a8.29,8.29,0,0,0,1.7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M360.6,76.76c0,.2-.24.46-.73.78q-6,4-8.06,4c-.9,0-1.36-.52-1.36-1.55a4.9,4.9,0,0,1,.34-1.75c.33-.81.49-1.23.49-1.26s0-.2-.15-.2a1.19,1.19,0,0,0-.24.1,28.05,28.05,0,0,1-3.11,2.57c-1.74,1.3-3,1.94-3.64,1.94A1,1,0,0,1,343,80.26a13.54,13.54,0,0,1,1.7-3.76,16.3,16.3,0,0,0,1.7-3.57c0-.36-.29-.53-.88-.53-.13,0-.19-.2-.19-.59a3.1,3.1,0,0,1,.92-.14c1.13,0,1.7.32,1.7,1a8.75,8.75,0,0,1-1.5,3.59,9.94,9.94,0,0,0-1.51,3.16c0,.25.11.38.34.38.52,0,1.79-.85,3.81-2.57a34.9,34.9,0,0,0,4.69-4.66c.48-.48.84-.73,1.06-.73a.56.56,0,0,1,.63.63,1.76,1.76,0,0,1-.34.88Q352.2,77.69,352.2,79c0,.81.37,1.21,1.12,1.21,1.13,0,3.19-1,6.16-3.06a4.83,4.83,0,0,1,.68-.43.43.43,0,0,1,.29-.15C360.55,76.57,360.6,76.64,360.6,76.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M387.49,47.06q0,4-7.15,14a105.69,105.69,0,0,1-11.83,14.11,9.31,9.31,0,0,0-.34,2.86,2.26,2.26,0,0,0,.49,1.38,1.31,1.31,0,0,0,1,.65,8.15,8.15,0,0,0,3.86-1.43l2.88-2a.44.44,0,0,1,.29-.14c.1,0,.15.07.15.19,0,.39-1,1.23-3,2.53s-3.61,2-4.51,2q-2.58,0-2.58-4.32c0-.16,0-.25-.09-.25-.95.72-1.9,1.44-2.84,2.19a5.89,5.89,0,0,1-3.08,1.36c-.75,0-1.12-.44-1.12-1.31,0-1.75.95-3.55,2.87-5.41s3.84-2.8,5.78-2.8q1.56-4.41,7.49-13.68Q383,45.8,386.61,45.8C387.2,45.8,387.49,46.22,387.49,47.06ZM368,71.72c0-.2-.06-.29-.19-.29a9.53,9.53,0,0,0-4.22,3.08,9,9,0,0,0-2.33,3.81c0,.52.29.77.77.77a7.83,7.83,0,0,0,2.63-1.39l2.13-1.55C367,75.44,367.38,74,368,71.72Zm17.62-24.08c0-.26-.09-.42-.29-.48q-4.2,2.33-9.92,12.47A96.74,96.74,0,0,0,369.48,72c-.13.42-.36,1.2-.68,2.33a87.9,87.9,0,0,0,10.79-13.45Q385.65,51.82,385.64,47.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M385.21,76.76c0,.2-.33.52-1,1q-3.8,2.72-6,2.71c-1.46,0-2.19-.61-2.19-1.84a8.93,8.93,0,0,1,1.65-4.56,15.23,15.23,0,0,1,2.09-2.72,1.26,1.26,0,0,1,1.07-.44c.26.07.38.15.38.24s-.55,1-1.67,2.82A9.29,9.29,0,0,0,377.93,78c0,1,.43,1.5,1.3,1.5q1.72,0,5.54-2.81a.43.43,0,0,1,.29-.15C385.16,76.57,385.21,76.64,385.21,76.76Zm-.73-11.35a1.25,1.25,0,0,1-.51.89,1.46,1.46,0,0,1-.9.47c-.52,0-.79-.3-.82-.88a1.15,1.15,0,0,1,.53-1,1.27,1.27,0,0,1,.83-.34C384.19,64.58,384.48,64.86,384.48,65.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M398.46,76.76c0,.13-.16.33-.49.59a6.72,6.72,0,0,1-4.32,1.79,3.76,3.76,0,0,1-2.33-.73c-1.49,2-3.1,2.92-4.85,2.92-1.3,0-1.94-.81-1.94-2.43q0-3.15,3.1-6.36,2.63-2.67,3.84-2.67c.52,0,.77.16.77.49,0,.09-.09.22-.29.39-.77.16-1.82,1-3.15,2.47a8,8,0,0,0-2.43,5.24q0,1.65,1.17,1.65a4.77,4.77,0,0,0,3.44-2,3.64,3.64,0,0,1-.92-2.52,5.16,5.16,0,0,1,.87-3,2.14,2.14,0,0,1,1.65-1.07c.59,0,.93.41,1,1.22a9,9,0,0,1-1.5,4.61,2.85,2.85,0,0,0,2.23.92A5.65,5.65,0,0,0,398,76.72a.43.43,0,0,1,.29-.15C398.41,76.57,398.46,76.64,398.46,76.76ZM393.12,73c0-.33-.12-.49-.34-.49s-.6.26-.92.78a3.65,3.65,0,0,0-.49,2,3.11,3.11,0,0,0,.44,1.7A7.4,7.4,0,0,0,393.12,73Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a871eae267e99bf19abe4b1edc715d9.svg";
export { ForwardRef as ReactComponent };